import { createSlice } from '@reduxjs/toolkit';
import { submitFlatData, submitSuburbanData } from '../../thunks';

interface IInitialState {
  redirectUrl: string | null;
  errorMessage: string | null;
}

const initialState: IInitialState = {
  redirectUrl: null,
  errorMessage: null,
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    deleteErrorMessage(state) {
      state.errorMessage = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(submitFlatData.fulfilled, (state, action) => {
        state.redirectUrl = action.payload as IInitialState['redirectUrl'];
      })
      .addCase(submitFlatData.rejected, (state, action) => {
        state.errorMessage = action.payload as IInitialState['errorMessage'];
      })
      .addCase(submitSuburbanData.fulfilled, (state, action) => {
        state.redirectUrl = action.payload as IInitialState['redirectUrl'];
      })
      .addCase(submitSuburbanData.rejected, (state, action) => {
        state.errorMessage = action.payload as IInitialState['errorMessage'];
      });
  },
});

export const {
  reducer: formReducer,
  actions: { deleteErrorMessage },
} = formSlice;
